import { useEffect, useState } from 'react'

const COMPACT_VIEWPORT_QUERY = '(max-width: 639px)'

export function useCompactViewport(): boolean {
  const [compact, setCompact] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(COMPACT_VIEWPORT_QUERY).matches,
  )

  useEffect(() => {
    const mediaQuery = window.matchMedia(COMPACT_VIEWPORT_QUERY)
    const onChange = () => setCompact(mediaQuery.matches)
    mediaQuery.addEventListener('change', onChange)
    return () => mediaQuery.removeEventListener('change', onChange)
  }, [])

  return compact
}

export const JOBS_TABLE_COMPACT_COLUMN_KEYS = [
  'jobNo',
  'position',
  'company',
  'status',
  'actions',
] as const
